import { render, staticRenderFns } from "./WabaSupsisAccountDeleted.vue?vue&type=template&id=38c79478&scoped=true"
import script from "./WabaSupsisAccountDeleted.vue?vue&type=script&lang=js"
export * from "./WabaSupsisAccountDeleted.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisAccountDeleted.vue?vue&type=style&index=0&id=38c79478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c79478",
  null
  
)

export default component.exports